const previewEditorDialogConstantAR = {
  previewEditorDialogTitle: 'معاينة',
};

export default previewEditorDialogConstantAR;
